import type { Item } from '@/lib/api/types/items';
import type { LinkedIdeasTabAdapter } from '../types';

export const createReadOnlyLinkedIdeasAdapter = ({
  item: _item,
}: {
  item: Item;
}): LinkedIdeasTabAdapter => {
  return {
    isEditable: () => false,
    isDisabled: () => false,
    isVisible: () => false,
  };
};
